import React from 'react';
import './PaymentIntegration.scss';

const PaymentIntegration = () => {

  return (

    <div className="main-right-side-section">
      <div className="payment-main-section">
        <section>
          <div className="payment-section-1">
            <div className="payment-section-1-inner">
              <p>PaymentIntegration Component</p>
            </div>
          </div>
        </section>
      </div>
    </div>
    
  );
}

PaymentIntegration.propTypes = {};

PaymentIntegration.defaultProps = {};

export default PaymentIntegration;
